import React from 'react';
import LocationTemplate from './LocationTemplate';

const EngelhardPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Engelhard"
      stateName="North Carolina"
      countyName="Hyde"
      zipCodes={["27824"]}
      latitude={35.5340}
      longitude={-75.9924}
      population={350}
      historicalFact="Named after Engelhard Hanff, a German businessman who established a fish processing plant in 1890."
      nearbyTowns={[
        "Swan Quarter, NC",
        "Fairfield, NC",
        "Lake Landing, NC",
        "Belhaven, NC",
        "Manteo, NC",
        "Columbia, NC",
        "Stumpy Point, NC",
        "Ocracoke, NC"
      ]}
    />
  );
};

export default EngelhardPage;